import { FC, ReactNode } from 'react'

type IProps = {
  icon: ReactNode
  title: string
  handleClick?: () => void
}
const UserMenuItem: FC<IProps> = ({ icon, title, handleClick }) => {
  return (
    <div
      className='flex items-center pb-3 text-sm text-gray-400 hover:text-blue-400 cursor-pointer duration-300 ease-in-out'
      onClick={handleClick}
    >
      {icon}
      <span className='mr-3'>{title}</span>
    </div>
  )
}

export default UserMenuItem
